import React, { useState, useEffect } from 'react';
import PropertyCard from './PropertyCardNew';
import PropertyDetailsList from "../../JsonData/property-details.json"
import { Button, Spin, Modal } from 'antd';
import { useParams, useHistory } from "react-router-dom";
import BuildingType from "../../JsonData/BuildingType.json"
import { deslugify } from '../../utils/slugify';



const SearchGridNew = ({ newPropertyHeader }) => {
    const { type, buildingType, constructionSlugs, locality, bedrooms } = useParams();
    const [filteredProperties, setFilteredProperties] = useState([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();


    let Buildingdata = BuildingType.BuildingType

    const typeMap = {
        buy: 'Buy',
        sell: 'Sell',
        rent: 'Rent/Lease'
    };

    const buildingTypeMap = {
        apartment: 'Apartment',
        townhouse: 'Townhouse',
        villas: 'Villas',
        penthouse: "Penthouse",
        'studio-apartment': 'Studio'
    };

    const constructionTypeMap = {
        ready: 'Ready',
        offplan: 'Off Plan'
    };

    const bedroomsMap = {
        "1bedrooms": "1bedrooms",
        "2bedrooms": "2bedrooms",
        "3bedrooms": "3bedrooms",
        "4bedrooms": "4bedrooms"
    };


    const searchParams = new URLSearchParams(window.location.search);

    const [propertyFor, setPropertyFor] = useState(
        type ? typeMap[type] : searchParams.get('PropertyFor') || ''
    );

    const [selectBuildingType, setSelectedBuildingType] = useState(
        type ? buildingTypeMap[buildingType] : searchParams.get('PropertyType') || ''
    )

    const [selectedConstructionType, setSelectedConstructionType] = useState(
        type ? constructionTypeMap[constructionSlugs] : searchParams.get('ConstructionType') || ''
    );

    const [selectLocality, setSelectedLocality] = useState(
        locality ? deslugify(locality) : searchParams.get('locality') || ''
    );

    const [selectBHK, setSelectedBHK] = useState(
        bedrooms ? bedroomsMap[bedrooms.toLowerCase()] : searchParams.get('BedroomsType') || ''
    );

    useEffect(() => {
        if (type === 'buy') {
            setPropertyFor('1');
        } else if (type === 'rent') {
            setPropertyFor('2');
        }
        else if (type === 'sell') {
            setPropertyFor('3');
        }
    }, [type]);


    useEffect(() => {

        setLoading(true)

        if (!PropertyDetailsList?.PropertyDetailsList) {
            console.error('Invalid property data structure');
            setFilteredProperties([]);
            setLoading(false);
            return;
        }

        let filtered = [...PropertyDetailsList.PropertyDetailsList];

        // Filter by property type (buy/rent)
        if (type) {
            const typeMap = {
                buy: 'Buy',
                sell: 'Sell',
                rent: 'Rent/Lease'
            };
            filtered = filtered.filter(prop =>
                prop.property_type.toLowerCase().includes(typeMap[type].toLowerCase()))
        }

        // Filter by building type
        if (buildingType) {
            const buildingTypeMap = {
                apartment: 'Apartment',
                townhouse: 'Townhouse',
                villas: 'Villas',
                penthouse: "Penthouse",
                'studio-apartment': 'Studio Apartment'
            };
            filtered = filtered.filter(prop =>
                prop.building_type.toLowerCase().includes(buildingTypeMap[buildingType].toLowerCase()))
        }

        // Filter by construction type (ready/offplan)
//       if (constructionSlugs && selectedConstructionType) {
//     filtered = filtered.filter(prop =>
//         prop.constructionType &&
//         prop.constructionType.toLowerCase() === selectedConstructionType.toLowerCase()
//     );
// }  bed rooms select karne ke baad me construction type ka filte kaam nahi kar raha hai 
if (constructionSlugs  && selectedConstructionType) {
    filtered = filtered.filter(prop => {
        if (!prop.constructionType) return false;

        const propType = prop.constructionType
            .toLowerCase()
            .replace(/\s+/g, ''); // "Off Plan" → "offplan"

        const selectedType = constructionSlugs
            .toLowerCase()
            .replace(/\s+/g, ''); // "offplan"

        return propType === selectedType;
    });
}



        // Filter by locality
        // if (locality) {
        //     const localitySlug = locality.replace(/-/g, ' ').toLowerCase();
        //     filtered = filtered.filter(prop => {
        //         if (!prop.locality) return false;

        //         // Normalize both the search term and property locality
        //         const propLocality = prop.locality.toLowerCase().replace(/\s+/g, ' ').trim();
        //         const searchLocality = localitySlug.replace(/\s+/g, ' ').trim();

        //         // More flexible matching options:
        //         return (
        //             propLocality === searchLocality || // Exact match
        //             propLocality.includes(searchLocality) || // Contains
        //             searchLocality.includes(propLocality) || // Reverse contains
        //             propLocality.replace(/\s/g, '') === searchLocality.replace(/\s/g, '') // No spaces match
        //         );
        //     });
        // }

        // if (selectBHK) {
        //     filtered = filtered.filter(prop =>
        //         prop.bedrooms_type && prop.bedrooms_type.toLowerCase() === selectBHK.toLowerCase()
        //     );
        // }
        if (selectBHK) {
            filtered = filtered.filter(prop => {
                if (!prop.bedrooms_type) return false;
                const bedroomsList = prop.bedrooms_type
                    .flatMap(item => item.split(",").map(b => b.trim().toLowerCase()));
                return bedroomsList.includes(selectBHK.toLowerCase());
            });
        }
// if (selectBHK) {
//     filtered = filtered.filter(prop => {
//         if (!prop.bedrooms_type || !Array.isArray(prop.bedrooms_type)) return false;

//         const bedroomsList = prop.bedrooms_type
//             .flatMap(item =>
//                 item.split(',').map(b => b.trim().toLowerCase())
//             );

//         return bedroomsList.includes(selectBHK.toLowerCase());
//     });
// }

        console.log('Filtered properties:', {
            filters: { type, buildingType, constructionSlugs, locality },
           
        });
        console.log("Resukts", filtered);

        if (!type && !buildingType && !constructionSlugs && !locality) {
            filtered = [...PropertyDetailsList.PropertyDetailsList];
        }

        setFilteredProperties(filtered);
        setLoading(false)
    }, [type, buildingType, constructionSlugs, locality, selectBHK]);

    const handleFilterChange = (key, value) => {
        let updatedType = type;
        let updatedBuilding = buildingType;
        let updatedConstruction = constructionSlugs;
        let updatedLocality = locality;
        let updatedBhk = selectBHK;


        if (key === 'PropertyFor') {
            updatedType = value === '1' ? 'buy' : value === '2' ? 'rent' : 'sell';
            setPropertyFor(value);
        }

        if (key === 'PropertyType') {
            const buildingSlugMap = {
                Apartment: 'apartment',
                Townhouse: 'townhouse',
                Villas: 'villas',
                Penthouse: 'penthouse',
                "Studio-Apartment": 'studio-apartment',
            };
            updatedBuilding = buildingSlugMap[value] || '';
            setSelectedBuildingType(value);
        }

        if (key === 'ConstructionType') {
            updatedConstruction = value.toLowerCase();
            setSelectedConstructionType(value);
        }

        // Locality
        if (key === 'Locality') {
            updatedLocality = value.toLowerCase().replace(/\s+/g, '-'); // "Damac Hills2" → "damac-hills2"
            setSelectedLocality(value);
        }

        if (key === 'BedroomsType') {
            updatedBhk = value;
            setSelectedBHK(value);
            setQueryParams('BedroomsType', value); // update query param
        }

        // console.log(updatedBuilding, "clear.....buildingtype");

        // if (!updatedBuilding) updatedBuilding = '';
        // if (!updatedConstruction) updatedConstruction = '';
        // if (!updatedLocality) updatedLocality = '';

        let path = '/properties';
        if (updatedType) path += `/${updatedType}`;
        if (updatedBuilding) path += `/${updatedBuilding}`;
        if (updatedConstruction) path += `/${updatedConstruction}`;
        if (updatedLocality) path += `/${updatedLocality}`;
        if (updatedBhk) path += `/${updatedBhk}`;

        history.push(path);
    }

    const setQueryParams = (key, value) => {
        if (value) {
            searchParams.set(key, value);
        } else {
            searchParams.delete(key);
        }
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        window.history.replaceState(null, '', newUrl);
    };


    // const handleResetFilter = () => {
    //     setPropertyFor('');
    //     setSelectedBuildingType('');
    //     setSelectedConstructionType('');
    //     setSelectedLocality('');
    //     setSelectedBHK('');

    //     const newUrl = `/properties`;
    //     history.push(newUrl);

    //     // Clear query params
    //      history.replace('/properties');
    //     const keysToRemove = ['PropertyFor', 'PropertyType', 'Ready_Underconstruction', 'locality', 'BHKType'];
    //     const newSearchParams = new URLSearchParams(window.location.search);
    //     keysToRemove.forEach((key) => newSearchParams.delete(key));
    //     window.history.replaceState(null, '', `${newUrl}?${newSearchParams.toString()}`);
    // };


    //   if (loading) {
    //     return <div>Loading properties...</div>;
    //   }

    return (
        <div className="search-page-wrap pd-top-100 pd-bottom-70">
            <div className="search-container">
                <div className="container">
                    <div className="row">
                        {/* {type ? `${type.charAt(0).toUpperCase() + type.slice(1)}` : 'All'} Properties
                        {buildingType ? ` - ${buildingType.replace('-', ' ')}` : ''}
                        {constructionSlugs ? ` - ${constructionSlugs === 'offplan' ? 'Off Plan' : 'Ready'}` : ''}
                        {locality ? ` in ${locality.replace(/-/g, ' ')}` : ''} */}

                        {/* Filters */}
                        {/* <div className="col-12 mb-4">
                            <div className="filter-bar d-flex flex-wrap align-items-center justify-content-between" style={{ gap: "15px" }}>
                                {/* Each filter dropdown */}
                        {/* Property For */}
                        {/* <div style={{ width: "190px" }}>
                                    <label className="d-block">Property For</label>
                                    <select
                                        className="form-control"
                                        value={propertyFor}
                                        // onChange={(e) => {
                                        //     setQueryParams('PropertyFor', e.target.value);
                                        //     setPropertyFor(e.target.value);
                                        // }}
                                        onChange={(e) => handleFilterChange('PropertyFor', e.target.value)}

                                    >
                                        <option value="">Select</option>
                                        <option value="1">Buy</option>
                                        <option value="2">Rent</option>
                                        <option value="3">Sell</option>
                                    </select>
                                </div> */}

                        {/* <div style={{ width: "190px" }}>
                                    <label className="d-block">Building Type</label>
                                    <select
                                        className="form-control"
                                        value={selectBuildingType}
                                        // onChange={(e) => {
                                        //     setQueryParams('PropertyType', e.target.value);
                                        //     setSelectedBuildingType(e.target.value);
                                        // }}
                                        onChange={(e) => handleFilterChange('PropertyType', e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {Buildingdata?.map((item) => (
                                            <option key={item.id} value={item.name}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div> */}

                        {/* Construction Type */}
                        {/* <div>
                                    <label className="d-block" style={{ width: "200px" }}>Construction Type</label>
                                    <select
                                        className="form-control"
                                        value={selectedConstructionType}
                                        // onChange={(e) => {
                                        //     setQueryParams('Ready_Underconstruction', e.target.value);
                                        //     setSelectedConstructionType(e.target.value);
                                        // }}
                                        onChange={(e) => handleFilterChange('ConstructionType', e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        <option value="ready">Ready To Move</option>
                                        <option value="offplan">Off Plan</option>
                                    </select>
                                </div> */}

                        {/* BHK Type */}
                        {/* <div style={{ width: "190px" }}>
                                    <label className="d-block">BHK Type</label>
                                    <select
                                        className="form-control"
                                        value={selectBHK}
                                        // onChange={(e) => {
                                        //     setQueryParams('BHKType', e.target.value);
                                        //     setSelectedBHK(e.target.value);
                                        // }}
                                        onChange={(e) => handleFilterChange('BHKType', e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        <option value="1BHK">1BHK</option>
                                        <option value="2BHK">2BHK</option>
                                        <option value="3BHK">3BHK</option>
                                        <option value="4BHK">4BHK</option>
                                    </select>
                                </div> */}

                        {/* Reset */}
                        {/* <div className="text-center">
                                    <button onClick={handleResetFilter} className="btn btn-yellow mt-3">
                                        <span className="left"><i className="fa fa-search" /></span> Reset Filter
                                    </button>
                                </div> */}
                        {/* </div> */}
                        {/* </div>  */}

                        {/* Property Results */}
                        <div className="col-12">
                            <div className="row mb-3">
                                <div className="col-md-9 col-sm-8 d-flex align-items-center" style={{ gap: "25px" }}>
                                    {/* <h6 className="filter-title mt-3 mb-lg-0">Total-Properties: {filteredProperties.length}</h6> */}
                                </div>
                            </div>

                            {loading ? (
                                <div className="text-center py-5">
                                    <Spin size="large" tip="Loading properties..." />
                                </div>
                            ) : (
                                <div className="row justify-content-center">
                                    {newPropertyHeader?.length > 0 ? (
                                        newPropertyHeader?.map(property => (
                                            <PropertyCard key={property.id} property={property} />
                                        ))
                                    ) : (
                                        <div className="no-results">
                                            <p>No properties available at the moment.</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default SearchGridNew;